<div #tooltipButton>
  <ng-content></ng-content>
</div>

<div
  #tooltipContent
  role="tooltip"
  class="invisible z-100 flex max-w-[280px] flex-col gap-8 rounded-2 bg-secondary-greys-800 p-8 text-secondary-greys-white shadow-tooltip"
  [class]="customClass()"
>
  @if (title()) {
    <div class="text-label-md-500">{{ title() }}</div>
  }
  @if (span()) {
    <span class="text-display-xs-500" [innerHTML]="body()"></span>
  } @else {
    <div class="text-body-xs-400">{{ body() }}</div>
  }
</div>
